//Menu
export const SELECT_TABS = "SELECT_TABS";
export const SET_BUTTONS = "SET_BUTTONS";
export const SET_SELECTED = "SET_SELECTED";
export const TOGGLE_SETTINGS = "TOGGLE_SETTINGS";
export const SET_TITLE = "SET_TITLE";
export const SET_SUBTITLE = "SET_SUBTITLE";
export const SET_TITLE_HANDLER = "SET_TITLE_HANDLER";
